import { render, staticRenderFns } from "./comentProduct.vue?vue&type=template&id=55e2a5ec"
import script from "./comentProduct.vue?vue&type=script&lang=js"
export * from "./comentProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports